import React, { useState } from "react";
import styles from "../Inbox.module.css";
import ActionButton from "../../button/ActionButton";
import PlaydateInviteOrganizerCreationWorkflow from "../../playdate/workflow/PlaydateInviteOrganizerCreationWorkflow";
import { useLayout } from "../../layout/LayoutContext";
import { Connection, PlaydateInvite } from "../../../gql/types";

interface NullStateViewProps {
    message?: string;
    onCreate: (success: boolean, invite?: PlaydateInvite) => void;
    connections?: Connection[];
    baseZIndex?: number;
}

const NullStateView: React.FC<NullStateViewProps> = ({
    message = "You haven’t sent any playdate invites yet.\nStart one now to plan a fun time!",
    onCreate,
    connections,
    baseZIndex,
}) => {
    const [showCreateFlow, setShowCreateFlow] = useState(false);
    const { baseZIndex: layoutZIndex } = useLayout();

    if (!baseZIndex) {
        baseZIndex = layoutZIndex + 1;
    }

    return (
        <>
            <div className={styles.fullPageCenteredContainer}>
                <div className={styles.nullStateMessage}>{message}</div>
                <div className={styles.nullStateButtonContainer}>
                    <ActionButton
                        onClick={() => setShowCreateFlow(true)}
                        textSize={"small"}
                        className={styles.nullStateButton}
                    >
                        Create Invite
                    </ActionButton>
                </div>
            </div>
            {showCreateFlow && <PlaydateInviteOrganizerCreationWorkflow
                featureParameters={{ connectionIDs: connections?.map((connection) => connection.connectionID) }}
                onBack={() => setShowCreateFlow(false)}
                onDataChange={onCreate}
                initialConnections={connections?.map((connection) => connection.participant)}
                baseZIndex={baseZIndex}
            />}
        </>
    );
};

export default NullStateView;
